// CA-1567: shared helper for forms.ts / client-logger.ts to resolve a root-relative URL
// against window.continuityUrl (wwwroot/js/app-url.js, loaded before this bundle via
// Views/Shared/_AppBase.cshtml -- see that file's remarks). Mirrors the same
// "log loudly, don't silently drop the prefix" guard api-fetch.js uses for the v2 bundle.
export function resolveAppUrl(url: string): string {
    if (!window.continuityUrl) {
        console.error(
            "[app-url-client] window.continuityUrl is missing -- is Views/Shared/_AppBase.cshtml " +
            "included in this page's layout, before main.min.js? URL will NOT be PathBase-resolved:",
            url
        );
        return url;
    }
    return window.continuityUrl.resolve(url);
}
